"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var throwIfInstanceOf = function throwIfInstanceOf(error, errorClass) {
  if (error instanceof errorClass) {
    throw error;
  }
};

/**
 * Rethrows an error if it is an instance of a given list of errors.
 * @param {number} errors, array of errors
 * @example
 * import { rethrowIfOneOf } from 'promise-frites';
 *
 * const rethrowMyErrors = rethrowIfOneOf(MyCustomError1, MyCustomError2);
 * const logError = () => {};
 * const notifyUser = () => {};
 *
 * Promise.resolve()
 *   .then(myBrokenFunction)
 *   .catch(rethrowMyErrors(notifyUser))
 *   .catch(logError);
 */
var rethrowIfOneOf = exports.rethrowIfOneOf = function rethrowIfOneOf() {
  for (var _len = arguments.length, errors = Array(_len), _key = 0; _key < _len; _key++) {
    errors[_key] = arguments[_key];
  }

  return function (fn) {
    return function (error) {
      return Promise.resolve().then(function () {
        return fn(error);
      }).then(function () {
        return errors.forEach(function (errorClass) {
          return throwIfInstanceOf(error, errorClass);
        });
      });
    };
  };
};